import { render, staticRenderFns } from "./AwardBudgetModal.vue?vue&type=template&id=4aa00574&scoped=true&"
import script from "./AwardBudgetModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardBudgetModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardBudgetModal.vue?vue&type=style&index=0&id=4aa00574&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa00574",
  null
  
)

export default component.exports